function isObject(value) {
    return Boolean(value && typeof value === "object" && !Array.isArray(value));
}

const PAYLOAD_TOO_LARGE_STATUS_CODE = 413;
const PAYLOAD_TOO_LARGE_MESSAGE =
    "Yüklemeye çalıştığın dosya izin verilen boyut sınırını aşıyor. Daha küçük bir dosya seçip tekrar dene.";
const POST_CREATION_FAILURE_MESSAGE =
    "Gönderi paylaşılamadı. Bağlantını kontrol edip tekrar dene.";
const POST_UPLOAD_FAILURE_MESSAGE =
    "Gönderi yüklenemedi. Seçtiğin dosya çok büyük olabilir veya bağlantı kesilmiş olabilir. Daha küçük bir dosya seçip tekrar dene.";
const PAYLOAD_TOO_LARGE_PATTERN =
    /(payload|request entity|content|file).*(too large|too big)|post_max_size|upload_max_filesize|status code 413/i;
const TECHNICAL_ERROR_MESSAGE_PATTERN =
    /^(network error|failed to fetch|load failed|request aborted|cannot read propert(?:y|ies)|timeout .* exceeded)/i;

function firstValidationMessage(errors) {
    if (!isObject(errors)) return "";

    for (const validationError of Object.values(errors)) {
        if (typeof validationError === "string" && validationError.trim()) {
            return validationError;
        }

        if (Array.isArray(validationError)) {
            const message = validationError.find(
                (value) => typeof value === "string" && value.trim()
            );
            if (message) return message;
        }
    }

    return "";
}

export function extractCreatedPost(payload) {
    const candidates = [payload?.data, payload?.item, payload?.post, payload];
    return (
        candidates.find(
            (post) => isObject(post) && post.id !== undefined && post.id !== null
        ) ||
        candidates.find(isObject) ||
        null
    );
}

export function extractWallPosts(payload) {
    const candidates = [payload, payload?.data, payload?.items, payload?.results];
    return candidates.find(Array.isArray) || [];
}

export function extractLikedUsers(payload) {
    const candidates = [
        payload,
        payload?.data,
        payload?.likes,
        payload?.items,
        payload?.results,
    ];
    return candidates.find(Array.isArray) || [];
}

export function hasCommentCollection(post) {
    return [post?.comments, post?.approved_comments, post?.post_comments].some(
        (comments) => Array.isArray(comments) || Array.isArray(comments?.data)
    );
}

export function extractPostComments(post) {
    const candidates = [
        post?.comments,
        post?.approved_comments,
        post?.post_comments,
    ];

    for (const comments of candidates) {
        if (Array.isArray(comments)) return comments;
        if (Array.isArray(comments?.data)) return comments.data;
    }
    return [];
}

export function extractReplyResponseTree(payload) {
    const candidates = [
        payload,
        payload?.comments,
        payload?.data,
        payload?.data?.comments,
    ];
    return candidates.find(Array.isArray) || [];
}

export function extractReplyResponseComment(payload) {
    const candidates = [payload?.reply, payload?.comment, payload?.data, payload];
    return candidates.find(isObject) || null;
}

export function apiErrorMessage(errorOrResult, fallback) {
    const source = errorOrResult?.error || errorOrResult;
    const errorData = source?.response?.data || source;
    const statusCode = Number(
        errorOrResult?.code ?? source?.response?.status ?? source?.status
    );
    const directMessage =
        typeof errorData === "string" ? errorData.trim() : "";
    const validationMessage =
        errorData?.errors?.text?.[0] ||
        errorData?.errors?.comment?.[0] ||
        firstValidationMessage(errorData?.errors);
    const message =
        directMessage ||
        validationMessage ||
        errorData?.message ||
        errorData?.error;

    if (
        statusCode === PAYLOAD_TOO_LARGE_STATUS_CODE ||
        (typeof message === "string" && PAYLOAD_TOO_LARGE_PATTERN.test(message))
    ) {
        return PAYLOAD_TOO_LARGE_MESSAGE;
    }

    if (
        typeof message === "string" &&
        message.trim() &&
        !TECHNICAL_ERROR_MESSAGE_PATTERN.test(message.trim())
    ) {
        return message.trim();
    }

    return fallback;
}

export function postCreationErrorMessage(errorOrResult, hasMediaFiles = false) {
    return apiErrorMessage(
        errorOrResult,
        hasMediaFiles
            ? POST_UPLOAD_FAILURE_MESSAGE
            : POST_CREATION_FAILURE_MESSAGE
    );
}
